import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useMarketTimeZone } from '@/features/country-scope';
import { formatDate } from '@/shared/lib/format';

import { useGlobalDiscounts } from '../api/global-discount.queries';

const LIVE = 'live';

/**
 * Pricing calculator: which global discount to apply. By default the country's running sale,
 * exactly as checkout applies it; or preview another one of the country (e.g. a scheduled sale).
 */
export function GlobalDiscountPicker({
  countryId,
  value,
  onChange,
}: {
  countryId: number;
  /** null = the running sale (as checkout). */
  value: number | null;
  onChange: (id: number | null) => void;
}) {
  const discounts = useGlobalDiscounts(countryId);
  const zone = useMarketTimeZone(countryId);
  const others = discounts.data?.filter((d) => d.status !== 'live') ?? [];
  if (others.length === 0 && value === null) return null;

  return (
    <div className="flex flex-col gap-1 text-xs sm:w-72">
      <Label htmlFor="calculator-global-discount" className="text-xs">
        Global discount
      </Label>
      <Select
        value={value === null ? LIVE : String(value)}
        onValueChange={(next) => onChange(next === LIVE ? null : Number(next))}
      >
        <SelectTrigger
          id="calculator-global-discount"
          size="sm"
          className="h-9 w-full text-xs"
          aria-label="Global discount"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={LIVE} className="text-xs">
            Running now (as checkout)
          </SelectItem>
          {others.map((d) => (
            <SelectItem key={d.id} value={String(d.id)} className="text-xs">
              Preview {d.percentOff}% · {formatDate(d.startsAt, zone)} →{' '}
              {formatDate(d.endsAt, zone)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
